import { UPDATE_PROMOTE_SETTING, UPDATE_FUNNEL } from "../types";
import { cloneDeep } from "lodash";
import { mapObject } from "../../utils/generalHelper";

const initialState = {
  promote_settings: {
    display_name: null,
    display_text: null,
    head_code: null,
    body_code: null,
    admin_settings: {},
  },
  guest_user_funnel: {
    welcome: null,
    webinar: null,
    checkout: null,
  },
  master_class_funnel: {
    welcome: null,
    webinar: null,
    checkout: null,
  },
  blueprint_funnel: {
    welcome: null,
    webinar: null,
    checkout: null,
  },
  live_opportunity_call_funnel: {
    welcome: null,
    webinar: null,
    checkout: null,
  },
  exclusive_member: {
    welcome: null,
    webinar: null,
    checkout: null,
  },
  dollar_trial_funnel: {
    welcome: null,
    webinar: null,
    checkout: null,
  },
  card_free_trial_funnel: {
    welcome: null,
    webinar: null,
    checkout: null,
  },
  annual_special_funnel: {
    welcome: null,
    webinar: null,
    checkout: null,
  },
  ninety_day_intro_plan: {
    welcome: null,
    webinar: null,
    checkout: null,
  },
  five_month_intro_plan: {
    welcome: null,
    webinar: null,
    checkout: null,
  },
  free_registration_no_card: {
    welcome: null,
    webinar: null,
    checkout: null,
  },
  instant_signup_payment: {
    welcome: null,
    webinar: null,
    checkout: null,
  },
};

const promoteReducer = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_PROMOTE_SETTING:
      const stateClone = cloneDeep(state);
      mapObject(stateClone.promote_settings, action.payload.promoteSettings);

      return {
        ...stateClone,
      };

    case UPDATE_FUNNEL:
      let funnel = cloneDeep({
        exclusive_member: state.exclusive_member,
        guest_user_funnel: state.guest_user_funnel,
        master_class_funnel: state.master_class_funnel,
        blueprint_funnel: state.blueprint_funnel,
        dollar_trial_funnel: state.dollar_trial_funnel,
        annual_special_funnel: state.annual_special_funnel,
        ninety_day_intro_plan: state.ninety_day_intro_plan,
        five_month_intro_plan: state.five_month_intro_plan,
        card_free_trial_funnel: state.card_free_trial_funnel,
        free_registration_no_card: state.free_registration_no_card,
        live_opportunity_call_funnel: state.live_opportunity_call_funnel,
        instant_signup_payment: state.instant_signup_payment,
      });
      mapObject(funnel, action.payload.funnel);

      return {
        ...state,
        ...funnel,
      };

    default:
      return state;
  }
};

export default promoteReducer;
